export const buildAccessoryFormData = (args) => {
  if(!args) return null;

  const {
    accessory,
    project_number,
    project_reference,
  } = args

  const {
    variant_id,
    quantity,
  } = accessory

  let form = new FormData();
  form.append('variant_id', variant_id);
  form.append('quantity', quantity);
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);

  return form;
}

export const buildForms = (args) => {
  if (!args) return [];
  const { accessories, project_number, project_reference } = args;
  if(!accessories) return [];
  return accessories.map((accessory) => buildAccessoryFormData({accessory, project_number, project_reference}));
}